import { LogsInitConfiguration } from '@datadog/browser-logs';

export enum LogLevel {
  None = 'none',
  Debug = 'debug',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}

export type ActiveLogLevel = Exclude<LogLevel, LogLevel.None>;

// reverse map
export const logLevelValues: Record<LogLevel, number> = {
  [LogLevel.None]: 0,
  [LogLevel.Debug]: 1,
  [LogLevel.Info]: 2,
  [LogLevel.Warn]: 3,
  [LogLevel.Error]: 4,
};

export type LoggerType = 'console' | 'datadog';

export type LoggerConfig =
  | { type: 'console'; logLevel: LogLevel }
  | {
      type: 'datadog';
      logLevel: LogLevel;
      config: LogsInitConfiguration;
    };

export type WriteToLog = (
  message: string,
  context?: object,
  error?: Error
) => void;

export interface ILogger {
  name: string;
  createNamedLogger(name: string): ILogger;
  setProjectContext(project?: {
    id: string;
    name: string;
    location: string;
  }): void;
  debug: WriteToLog;
  info: WriteToLog;
  warn: WriteToLog;
  error: WriteToLog;
}
